/* Essent — fix-layer script. Added 2026-08-08.
   Two independent behaviours, kept in one file so the layer stays one script
   tag. Split them when this folds into the repo.
     1. Per-millilitre price, derived from the price the shopper can see.
     2. Tab motion — a sliding indicator and a panel transition.
*/

/* ===========================================================================
   1. PER-ML

   The shop's base currency is USD and its money_format is owned by Convercy,
   which rewrites every <span class=cvc-money> after render and rounds the
   result to its own granularity. Computing per-ml server-side from USD cents
   therefore produced a figure that did not divide the price on screen: a 30 ml
   at Rs. 1,500 read "Rs. 100.00 /ml" instead of Rs. 50.00.

   So the arithmetic happens last, on the rendered string: read the converted
   price, divide by the millilitres, and re-emit it in that string's own
   formatting. Whatever Convercy does to the price, per-ml always divides it.

   If this script does not run, the per-ml slots stay empty. An absent per-ml
   is better than a wrong one.
   =========================================================================== */
(function () {
  'use strict';

  var GROUP = /\B(?=(\d{3})+(?!\d))/g;
  var writing = false;
  var timer = null;

  function read(el) {
    if (!el) return null;
    var text = (el.textContent || '').replace(/ /g, ' ').trim();
    var match = text.match(/\d[\d.,\s]*\d|\d/);
    if (!match) return null;

    var raw = match[0].replace(/\s/g, '');
    var lastDot = raw.lastIndexOf('.');
    var lastComma = raw.lastIndexOf(',');
    var last = Math.max(lastDot, lastComma);
    var decSep = '';
    var decimals = 0;
    var groupSep = '';

    if (last > -1) {
      var tail = raw.length - last - 1;
      if (tail === 1 || tail === 2) {
        decSep = raw.charAt(last);
        decimals = tail;
        groupSep = decSep === '.' ? ',' : '.';
      } else {
        groupSep = raw.charAt(last);
      }
    }

    var numeric = raw;
    if (groupSep) numeric = numeric.split(groupSep).join('');
    if (decSep) numeric = numeric.replace(decSep, '.');

    var value = parseFloat(numeric);
    if (!isFinite(value) || value <= 0) return null;

    var at = text.indexOf(match[0]);
    return {
      value: value,
      decimals: decimals,
      decSep: decSep || '.',
      groupSep: groupSep || ',',
      prefix: text.slice(0, at),
      suffix: text.slice(at + match[0].length)
    };
  }

  function write(shape, value) {
    var fixed = value.toFixed(shape.decimals);
    var parts = fixed.split('.');
    var out = parts[0].replace(GROUP, shape.groupSep);
    if (parts.length > 1) out += shape.decSep + parts[1];
    return (shape.prefix + out + shape.suffix).trim();
  }

  function mlOf(el) {
    var n = Number(el.getAttribute('data-ml') || 0);
    return isFinite(n) && n > 0 ? n : 0;
  }

  function update() {
    writing = true;

    var pressed = document.querySelector('.buy [data-size][aria-pressed="true"]');
    var pressedMl = pressed ? mlOf(pressed) : 0;

    var slots = document.querySelectorAll('[data-perml]');
    for (var i = 0; i < slots.length; i++) {
      var slot = slots[i];
      var box = slot.closest('.buy__price, .price');
      if (!box) continue;

      var shape = read(box.querySelector('[data-price]'));
      var ml = mlOf(slot);
      if (box.classList.contains('buy__price') && pressedMl) ml = pressedMl;

      var next = (shape && ml) ? write(shape, shape.value / ml) + '/ml' : '';
      if (slot.textContent !== next) slot.textContent = next;
    }

    var pills = document.querySelectorAll('[data-size]');
    for (var j = 0; j < pills.length; j++) {
      var pill = pills[j];
      var out = pill.querySelector('[data-pill-perml]');
      if (!out) continue;

      var text;
      if (pill.getAttribute('data-available') === 'false') {
        text = 'sold out';
      } else {
        var src = read(pill.querySelector('[data-pill-price]'));
        var pml = mlOf(pill);
        text = (src && pml) ? write(src, src.value / pml) + '/ml' : '';
      }
      if (out.textContent !== text) out.textContent = text;
    }

    setTimeout(function () { writing = false; }, 0);
  }

  function schedule() {
    if (writing) return;
    clearTimeout(timer);
    timer = setTimeout(update, 90);
  }

  function boot() {
    update();

    if ('MutationObserver' in window) {
      new MutationObserver(schedule).observe(document.body, {
        subtree: true, childList: true, characterData: true
      });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-size], [data-quickview]')) schedule();
    });
    document.addEventListener('shopify:section:load', schedule);

    setTimeout(update, 500);
    setTimeout(update, 1500);
    setTimeout(update, 3000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ===========================================================================
   2. TAB MOTION

   The tabbed grid changed the selected tab's colour and swapped `hidden` on
   the panels. Nothing moved, so the switch read as a redraw rather than as a
   transition.

   Two additions, both outside essent.js so its tabs() keeps owning state:
     - an indicator that slides and resizes to the selected tab
     - a panel that fades and lifts in when its `hidden` is removed

   The panel transition is entry-only by design. essent.js sets hidden
   synchronously, so there is no frame in which to animate the outgoing panel
   without taking that ownership away from it.
   =========================================================================== */
(function () {
  'use strict';

  function initTabs(list) {
    if (list.dataset.motion) return;
    list.dataset.motion = '1';

    var ink = document.createElement('span');
    ink.className = 'tabs__ink';
    ink.setAttribute('aria-hidden', 'true');
    list.appendChild(ink);

    function move(animate) {
      var on = list.querySelector('[role="tab"][aria-selected="true"]');
      if (!on) return;
      if (!animate) ink.style.transition = 'none';
      ink.style.width = on.offsetWidth + 'px';
      ink.style.transform = 'translateX(' + on.offsetLeft + 'px)';
      if (!animate) {
        void ink.offsetWidth;
        ink.style.transition = '';
      }
    }

    move(false);

    list.addEventListener('click', function (e) {
      if (!e.target.closest('[role="tab"]')) return;
      requestAnimationFrame(function () { move(true); });
    });
    list.addEventListener('keyup', function () {
      requestAnimationFrame(function () { move(true); });
    });
    window.addEventListener('resize', function () { move(false); });

    /* Web fonts land after first paint and change every tab's width. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { move(false); });
    }
  }

  function initPanels(root) {
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (records) {
      records.forEach(function (r) {
        var el = r.target;
        if (r.attributeName !== 'hidden' || el.hidden) return;
        if (!el.classList.contains('tabpanel')) return;
        el.classList.add('is-entering');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { el.classList.remove('is-entering'); });
        });
      });
    }).observe(root, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.tabs[role="tablist"]'), initTabs);
    Array.prototype.forEach.call(document.querySelectorAll('[data-tabs]'), initPanels);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
